<div class="aside-sticky-container">
  <jhi-bary-card [titleKey]="getTitleEstimationPrice()">
    <div body>
      <jhi-bary-title [title]="'LABEL.OFFER_NAME.VALUE' | translate: { name: offer!.alias }" *ngIf="offer && !offer.isQuotation"></jhi-bary-title>
      <ng-container *ngIf="lastEstimate && isDisplayPrice && !isDisplayQuotation">
        <jhi-cart-value
          *ngIf="lastEstimate.estimation.basePrice >= 0"
          [label]="keyLabelBasePrice | translate"
          [suffix]="'SUFFIX.PRE_TAXES' | translate"
          [value]="lastEstimate.estimation.basePrice | currency: 'EUR'"
        ></jhi-cart-value>
        <jhi-cart-value
          *ngIf="!insuranceIncluded && lastEstimate.estimation.insurance"
          [label]="'LABEL.INSURANCE_FEES' | translate"
          [suffix]="'SUFFIX.PRE_TAXES' | translate"
          [value]="lastEstimate.estimation.insurance | currency: 'EUR'"
        ></jhi-cart-value>
        <jhi-cart-value *ngIf="insuranceIncluded && !onlyPriceHt" [label]="'LABEL.INSURANCE_FEES' | translate" [value]="'LABEL.INCLUDED_FEM' | translate"></jhi-cart-value>
        <jhi-cart-group-value
          *ngIf="lastEstimate.estimation.pricingOptions && lastEstimate.estimation.pricingOptions.length > 0"
          [label]="'LABEL.OPTIONS' | translate"
          [suffix]="'SUFFIX.PRE_TAXES' | translate"
          [items]="asPricingItems()"
          [value]="optionsAmount | currency: 'EUR'"
        ></jhi-cart-group-value>
        <jhi-cart-group-value
          *ngIf="getOtherTaxes().length > 0"
          [label]="'LABEL.OTHER_TAXES' | translate"
          [suffix]="'SUFFIX.PRE_TAXES' | translate"
          [items]="asTaxItems()"
          [value]="taxesAmount | currency: 'EUR'"
        ></jhi-cart-group-value>
        <jhi-cart-group-value
          *ngIf="lastEstimate.estimation.gazoleTaxAmount && lastEstimate.estimation.gazoleTaxRate"
          label="{{ 'LABEL.FUEL_TAX_RATE' | translate: { gazoleTaxRate: gazoleTaxFormattedValue() } }}"
          [suffix]="'SUFFIX.PRE_TAXES' | translate"
          [items]="asGazoleTaxItems()"
          [value]="lastEstimate.estimation.gazoleTaxAmount | currency: 'EUR'"
        ></jhi-cart-group-value>
        <hr class="mt-0" *ngIf="!onlyPriceHt" />
        <jhi-cart-value
          [label]="'LABEL.TOTAL_PRE_TAXES_PRICE' | translate"
          [suffix]="'SUFFIX.PRE_TAXES' | translate"
          [value]="lastEstimate.estimation.priceHT | currency: 'EUR'"
        ></jhi-cart-value>
        <jhi-cart-value
          *ngIf="lastEstimate.estimation.priceHT && (isDisplayQuotation || isDisplayQuotationResponse)"
          [label]="'LABEL.TOTAL_FULL_TAXES_PRICE' | translate"
          [suffix]="'SUFFIX.FULL_TAXES' | translate"
          [value]="lastEstimate.estimation.priceHT * 1.2 | currency: 'EUR'"
          color="color-dark"
        ></jhi-cart-value>
        <div class="row" *ngIf="showButton">
          <div class="col-12 my-1">
            <jhi-bary-button
              *ngIf="hasNextStep"
              [block]="true"
              color="primary"
              [label]="'BTN.NEXT_STEP' | translate"
              (clickEvent)="nextStep()"
              [disabled]="disabled"
              data-id-cypress="next-step"
            ></jhi-bary-button>
            <jhi-bary-button
              *ngIf="!hasNextStep"
              [block]="true"
              color="primary"
              [label]="'BTN.VALIDATE_MY_QUOTATION' | translate"
              (clickEvent)="nextStep(true)"
              [disabled]="disabled"
              data-id-cypress="validate"
            ></jhi-bary-button>
          </div>
          <div class="col-12 my-1">
            <jhi-bary-button
              *ngIf="hasPreviousStep"
              [block]="true"
              color="primary"
              [outline]="true"
              [label]="'BTN.PREVIOUS_STEP' | translate"
              (clickEvent)="previousStep()"
              [disabled]="disabled"
            ></jhi-bary-button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isDisplayQuotation && !isDisplayError">
        <div class="row">
          <div class="col-12">
            <p class="bold text-warning" jhiTranslate="LABEL.ON_QUOTATION_ONLY"></p>
          </div>
        </div>
        <div class="row" *ngIf="showButton">
          <div class="col-12 my-1">
            <jhi-bary-button
              *ngIf="hasNextStep"
              [block]="true"
              color="primary"
              [label]="'BTN.NEXT_STEP' | translate"
              (clickEvent)="nextStep()"
              [disabled]="disabled"
              data-id-cypress="next-step"
            ></jhi-bary-button>
            <jhi-bary-button
              *ngIf="!hasNextStep"
              [block]="true"
              color="primary"
              data-id-cypress="btn-demande-devis"
              [label]="'BTN.QUOTATION_REQUEST' | translate"
              (clickEvent)="nextStep(true)"
              [disabled]="disabled"
            ></jhi-bary-button>
          </div>
          <div class="col-12 my-1">
            <jhi-bary-button
              *ngIf="hasPreviousStep"
              [block]="true"
              color="primary"
              [outline]="true"
              [label]="'BTN.PREVIOUS_STEP' | translate"
              (clickEvent)="previousStep()"
              [disabled]="disabled"
            ></jhi-bary-button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isDisplayError">
        <div class="row">
          <div class="col-12">
            <p class="bold text-danger" jhiTranslate="LABEL.INVALID_TRANSPORT"></p>
          </div>
        </div>
        <div class="row" *ngIf="showButton">
          <div class="col-12 my-1">
            <jhi-bary-button *ngIf="hasNextStep" [block]="true" color="primary" [label]="'BTN.NEXT_STEP' | translate" (clickEvent)="nextStep()"></jhi-bary-button>
          </div>
          <div class="col-12 my-1">
            <jhi-bary-button
              *ngIf="hasPreviousStep"
              [block]="true"
              color="primary"
              [outline]="true"
              [label]="'BTN.PREVIOUS_STEP' | translate"
              (clickEvent)="previousStep()"
            ></jhi-bary-button>
          </div>
          <div class="col-12 my-1">
            <jhi-bary-button [block]="true" color="danger" [label]="'BTN.CANCEL_TRANSPORT' | translate" (clickEvent)="cancel()"></jhi-bary-button>
          </div>
        </div>
      </ng-container>
      <ng-container>
        <hr class="mt-2" *ngIf="showButton" />
        <div class="col-12 text-center" *ngIf="showButton">
          <jhi-bary-link (click)="changeOffer()" [label]="'BTN.CHANGE_OFFER' | translate"></jhi-bary-link>
        </div>
      </ng-container>
    </div>
  </jhi-bary-card>
</div>
